module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/click.16d8f636.svg";